import { authService } from '../../services/auth/authService';
import type { User as FirebaseUser } from 'firebase/auth';

/**
 * GetCurrentUserUseCase
 * 
 * Gets the currently authenticated Firebase user.
 * Returns FirebaseUser | null - no remapping needed for Firebase Auth user.
 */
export class GetAuthFirebaseUserUseCase {
    execute(): FirebaseUser | null {
        return authService.getCurrentUser();
    }
}

export const getAuthFirebaseUserUseCase = new GetAuthFirebaseUserUseCase();
